import WindowInterface from "Interfaces/WindowInterface"
import UserAccount from "Models/UserAccount"
import GooglePlace from "Models/GooglePlace"
import {MultiLingualEntity} from "Models/MultiLingualEntity"
declare const window: WindowInterface
import globals from "../globals"

class Attributes {
  public id: string = ''
  public title: string = ''
  public country: string = 'Canada'
  public hasLocation: string = ''
  public location: GooglePlace = new GooglePlace()
  public standing: string = ''
  public legalName: string = ''
  public type: string = ''
  public typeOther: string = ''
  public taxStatus: string = ''
  public taxStatusOther: string = ''
  public contactFirstName: string = ''
  public contactLastName: string = ''
  public contactPosition: string = ''
  public contactPositionOther: string = ''
  public contactPhone: string = ''
  public contactAlternatePhone: string = ''
  public contactEmail: string = ''
  public website: string = ''
  public feedback: string = ''
  public ready: string = ''
  public mtg_enabled: boolean = false
  public field_mtg: any = {}
  public mentor_city_enabled: boolean = false
  serialize() {
    return {
      field_has_location: this.hasLocation,
      field_physical_location: this.location.serialize(),
      field_legal_name: this.legalName,
      field_type: this.type,
      field_type_other: this.typeOther,
      field_tax_status: this.taxStatus,
      field_tax_status_other: this.taxStatusOther,
      field_first_name: this.contactFirstName,
      field_last_name: this.contactLastName,
      field_position: this.contactPosition,
      field_position_other: this.contactPositionOther,
      field_phone: this.contactPhone,
      field_alt_phone: this.contactAlternatePhone,
      field_email: this.contactEmail,
      field_web_address: this.website,
      field_feedback: this.feedback,
      field_ready: this.ready,
      field_mtg_enabled: this.mtg_enabled,
      field_mentor_city_enabled: this.mentor_city_enabled
    }
  }
}

class LocalizedAttributes {
  public field_display_title: string = ''
  public field_description: string = ''
  constructor(data?: any) {
    if(data) {
      this.field_display_title = data.field_display_title
      this.field_description = data.field_description
    }
  }
}

export default class Organization extends MultiLingualEntity implements EntityInterface, MultiLingualEntityInterface {
  private type: string = 'organization'
  protected url: string = `/a/node/${this.type}`
  private createUrl: string = `/a/app/organization`
  public queryString: string = 'include=field_administrators,field_logo&fields[file--file]=uri,url'

  public attributes: Attributes = new Attributes()
  public localizedAttributes = new Map<string, LocalizedAttributes>()

  public accounts: UserAccount[] = []
  public director: boolean = false

  constructor(data?: JSONAPIDocumentInterface) {
    super()
    this.document.type = `node--${this.type}`
    window.app.languages.list.forEach((language) => {
      this.localizedAttributes[language.langcode] = new LocalizedAttributes()
    })
    if(data) {
      this.setData(data)
    }
  }

  async load(): Promise<any> {
    await super.load()
    if(globals.app.user.id) {
      let response = await window.api.get(`/a/app/organization/${this.document.id}/me`)
      this.director = response.data.data.director
    }
  }

  setData(data: any) {
    this.localizedAttributes[data.attributes.langcode].field_display_title = data.attributes.field_display_title
    this.attributes.title = data.attributes.title
    this.attributes.standing = data.attributes.field_standing
    this.attributes.contactEmail = data.attributes.field_email
    this.document.attributes = {}
    this.document.attributes.title = data.attributes.title
    this.attributes.id = data.id
    this.document.id = data.id

    this.attributes.legalName = data.attributes.field_legal_name
    this.attributes.type = data.attributes.field_type
    this.attributes.typeOther = data.attributes.field_type_other
    this.attributes.taxStatus = data.attributes.field_tax_status
    this.attributes.taxStatusOther = data.attributes.field_tax_status_other

    this.attributes.contactFirstName = data.attributes.field_first_name
    this.attributes.contactLastName = data.attributes.field_last_name
    this.attributes.contactPosition = data.attributes.field_position
    this.attributes.contactPositionOther = data.attributes.field_position_other
    this.attributes.contactPhone = data.attributes.field_phone
    this.attributes.contactAlternatePhone = data.attributes.field_alt_phone

    this.attributes.hasLocation = data.attributes.field_has_location
    this.attributes.location = new GooglePlace(data.attributes.field_physical_location)

    this.attributes.website = data.attributes.field_web_address
    this.attributes.feedback = data.attributes.field_feedback

    this.attributes.ready = data.attributes.field_ready
    this.attributes.field_mtg = data.attributes.field_mtg
    this.attributes.mtg_enabled = data.attributes.field_mtg_enabled == "1"
    this.attributes.mentor_city_enabled = data.attributes.field_mentor_city_enabled == "1"
  }

  setLocalizedAttributes(langcode: string, attributes: any) {
    this.localizedAttributes[langcode] = new LocalizedAttributes(attributes)
  }

  serializeRelationships(): any {
    let result: any = {}
    result.field_administrators = {
      data: this.accounts
    }
    return result
  }

  protected setIncluded(included: any) {
    this.accounts = []
    included?.forEach((row) => {
      if(row.type == 'node--organization') return
      if(row.type == 'file--file') return
      this.accounts.push(new UserAccount(row))
    })
    let files = included?.filter(row => row.type == 'file--file')
    if(files?.length) {
      this.managedFile.setData(files[0])
    }
  }

  public getTitle(): string {
    let lang = globals.app.language.langcode
    let title = this.localizedAttributes[lang].field_display_title || ''
    if(title == '' && lang != 'en') {
      title = this.localizedAttributes['en'].field_display_title
    }
    return title
  }

}